// import { baseUrl, headers, jwtHeaders, jwtHeaders2, logoutUtil } from '../common/data';
import { baseUrl,jwtHeaders, jwtHeaders2} from '../common/data';

export const fetchAllStaffs = async () => {
  const response = await fetch(`${baseUrl}/api/staff/getallstaff`, { headers: jwtHeaders()});
  const resData = await response?.json();
  // console.log('all staffs data=================================================>', resData);
  return resData;
};

export const createStaff = async (data) => {
  const response = await fetch(`${baseUrl}/api/staff/create`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  // console.log('add staff data=================================================>', resData);
  return resData;
};

export const deleteStaff = async (data) => {
  const response = await fetch(`${baseUrl}/api/staff/deletestaff/${data}`, {
    method: 'DELETE',
    // headers: headers,
    headers:jwtHeaders(),
  });
  const resData = await response?.json();
  // console.log('staff delete data=================================================>', resData);
  return resData;
};

export const getStaffById = async (id, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getastaff/${id}${queryParams ? queryParams : ''}`,
    { headers:jwtHeaders()},
  );
  const resData = await response?.json();
  // console.log('active staff data=================================================>', resData);
  return resData;
};

export const createAttandence = async (id, data) => {
  const response = await fetch(`${baseUrl}/api/staff/attendance/${id}`, {
    method: 'POST',
    body: data,
    headers: jwtHeaders2(),
  });
  const resData = await response?.json();
  // console.log('attandence add data=================================================>', resData);
  return resData;
};

export const forgotpassowrd = async (data) => {
  const response = await fetch(`${baseUrl}/api/staff/forgotpassword`, {
    method: 'POST',
    body: JSON.stringify(data),
    // headers,
    headers:jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};

export const fetchAttendanceByStaffId = async (id, queryParmas) => {
  const response = await fetch(
    `${baseUrl}/api/staff/attendance/${id}${queryParmas ? queryParmas : ''}`,
    {
      method: 'GET',
      // headers,
      headers:jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const fetchOverview = async (id, queryParmas) => {
  const response = await fetch(
    `${baseUrl}/api/staff/staffoverview/${id}${queryParmas ? queryParmas : ''}`,
    {
      method: 'GET',
      // headers,
      headers:jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

// export const salarySlip = async (id, queryParams) => {
//   const response = await fetch(
//     `${baseUrl}/api/staff/salaryslip/${id}?branchId=${queryParams}&monthName=${queryParams}`,
//     {
//       method: 'GET',
//       headers: jwtHeaders(),
//       body: JSON.stringify(),
//     }
//   );
//   const resData = await response.json();
//   return resData;
// };

// co
export const salarySlip = async (id, queryParams) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/staff/salaryslip/${id}${queryParams}`,
      {
        method: 'GET',
        headers: jwtHeaders(), // Assuming jwtHeaders() returns the necessary headers
      }
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const resData = await response.json();
    return resData;
  } catch (error) {
    console.error('Error fetching salary slip:', error);
    throw error; // Rethrow the error to handle it in the component
  }
};

export const fetchStaffLeaves = async (staffId, queryParams) => {
  const response = await fetch(
    `${baseUrl}/api/staff/getStaffLeaves/${staffId}${queryParams ? queryParams : ''}`,
    {
      method: 'GET',
      headers: jwtHeaders(),
    },
  );
  const resData = await response?.json();
  return resData;
};

export const applyStaffLeave = async (staffId, data) => {
  const response = await fetch(`${baseUrl}/api/staff/applyLeave/${staffId}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};